import { ServiceType } from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';
import { FeatureFlag } from '@/shared/api/protocol-ts/model/dto_organization_pb';
import { useAppSelector } from '@/shared/hooks';

import { billingModel } from '@/entities/billing';
import { composedModel } from '@/entities/composed';
import { organizationModel } from '@/entities/organization';
import { patientModel } from '@/entities/patient';

// Album cards have no room for the storage-blocked tooltip of the upload
// button, so upload is hidden instead of disabled.
export const useDentalPhotoAlbumPermissions = (patientID: string) => {
  const { CanUploadDentalPhoto, CanEditAlbums } = useAppSelector(
    patientModel.selectors.selectPatientYourPermissions(patientID),
  );
  const isUploadServiceActive = useAppSelector(
    billingModel.selectors.selectIsServiceActiveByType(
      ServiceType.ServiceType_Enable_UploadDentalPhoto,
    ),
  );
  const isStorageBlocked = useAppSelector(
    composedModel.selectors.selectIsStorageBlocked,
  );
  const isForbidUploadsFromWeb = useAppSelector(
    organizationModel.selectors.selectFeatureFlag(
      FeatureFlag.FeatureFlag_Forbid_UploadsFromWeb,
    ),
  );

  return {
    canEditAlbums: CanEditAlbums,
    canUpload:
      CanUploadDentalPhoto &&
      isUploadServiceActive &&
      !isStorageBlocked &&
      !isForbidUploadsFromWeb,
  };
};
